<script lang="ts">
	import { businessTimezone } from '#lib/stores/time.js';
	import { isDarkMode } from '#lib/stores/dark-mode.js';
	import { t } from '#lib/stores/i18n.js';
	import ReservatooLogo from '#lib/svg/reservatooLogo.svg.svelte';
	import { getWidgetBackgroundContrastHexColor } from '#lib/widget/theme.js';
	import { widgetConfig, widgetContent } from '#lib/widget/core.js';
	import { onMount } from 'svelte';
	import LanguageSelector from './LanguageSelector.svelte';

	$businessTimezone = $widgetContent.business.timezone;

	let logoColor = $state('#000000');
	function updateLogoOnColorSchemeChange(_isDarkMode: boolean) {
		logoColor = getWidgetBackgroundContrastHexColor($widgetConfig.theme);
	}
	onMount(() => {
		updateLogoOnColorSchemeChange(false);
	});
	$effect(() => {
		updateLogoOnColorSchemeChange($isDarkMode);
	});
</script>

{#if !$widgetContent.business.isWhitelabel}
	<footer
		class="w-fit mx-auto text-sm flex items-center gap-2 justify-center py-2 mt-8 transform transition-transform duration-300 hover:scale-105"
	>
		<LanguageSelector />
		<div class="flex items-center gap-0.5">
			{$t('widget-external.powered_by')}
			<a href="https://www.reservatoo.com/?ref=widget" target="_blank">
				<ReservatooLogo className="h-5" color={logoColor} />
			</a>
		</div>
	</footer>
{/if}
